__turbopack_context__.v({
  "container": "Container-module__8w9_bq__container",
  "title": "Container-module__8w9_bq__title",
});
